<template>
  <div class="search-result">
    <h1>搜索结果</h1>
    <div class="search-container">
      <div class="total" v-if="!$route.params.type">
        共检索到匹配结果
        <em>{{total}}</em>条
      </div>
      <ul class="sys-type">
        <li
          v-for="(item,index) in resultList"
          :key="index"
          :style="{order:searchResultWeight[item.title]}"
        >
          <system-section
            v-if="item.title==='系统'"
            :sectionData="item.items"
            :hideContent="!$route.params.type"
          />
          <doc-section
            v-else-if="item.title==='文档'"
            :sectionData="item.items"
            :hideContent="!$route.params.type"
          />
          <employee-section
            v-else-if="item.title==='人员'"
            :sectionData="item.items"
            :hideContent="!$route.params.type"
          />
          <todo-section
            v-else-if="item.title==='待办'"
            :sectionData="item.items"
            :hideContent="!$route.params.type"
          />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import systemSection from "./components/system-section";
import docSection from "./components/doc-section";
import todoSection from "./components/todo-section";
import employeeSection from "./components/employee-section";

export default {
  name: "app",
  components: {
    systemSection,
    employeeSection,
    todoSection,
    docSection
  },
  data() {
    return {
      resultList: [],
      total: "",
      searchResultWeight: {
        系统: 1,
        人员: 2,
        文档: 3,
        待办: 4
      },
      typeMap: {
        审批中心: "todo",
        会议: "todo",
        工单: "todo",
        个人待办: "todo",
        helpdesk: "document",
        云杉制度: "document",
        document: "document",
        todo: "todo",
        user: "user",
        system: "system"
      },
      totalList: []
    };
  },
  methods: {
    search() {
      const { type, key } = this.$route.params;
      const search = this.typeMap[type] || "all";
      _api.home.getSearch({ keywords: key, search: search }).then(res => {
        this.$set(this, "resultList", res.data);
        this.total = 0;
        this.resultList.forEach(m => {
          if (m.items.length > 0 && m.items[0].items) {
            m.items.forEach(subItem => {
              console.log(subItem.items);
              this.totalList.concat(subItem.items);
              this.total += subItem.items.length;
            });
          } else {
            this.totalList.concat(m.items);
            this.total += m.items.length;
          }
        });
      });
    }
  },
  watch: {
    $route: {
      handler(to, from) {
        console.log(to);
        this.resultList = [];
        this.search();
      },
      immediate: true
    }
  },
  created() {
    this.search();
  }
};
</script>

<style lang="scss">
.search-result {
  width: 1280px;
  margin: 20px auto;
  padding: 0 100px;

  h1 {
    font-size: 24px;
    margin-bottom: 20px;
  }
  a:hover {
    color: #4272ab;
  }

  .search-container {
    padding: 23px 0 0 0;
    font-size: 14px;
    .total {
      margin-bottom: 20px;
    }
  }

  .type-title {
    width: 100%;
    height: 40px;
    line-height: 40px;
    padding-right: 20px;
    box-sizing: border-box;
    display: block;
    font-size: 16px;
    color: #333333;

    background-color: rgba(248, 248, 248, 1);
    padding-left: 10px;
    font-weight: 600;

    i {
      color: rgba(143, 149, 172, 1);
      font-size: 12px;
      font-weight: normal;
      margin-left: 6px;
    }
  }
  .sys-type {
    margin-bottom: 30px;
    display: flex;
    flex-direction: column;

    & > li {
      order: 99;
    }

    & > li + li {
      margin-top: 20px;
    }
  }
}

.view-over {
  // height: calc(100vh - 280px);
}
.el-pagination {
  text-align: center;
  color: #606266;
  margin-top: 20px;
  padding:0;
}
.result-item {
  display: block;
  margin: 15px 0;
  
}
</style>
